<template>
  <div class="care-label-background">
    <link href="https://fonts.cdnfonts.com/css/harmonyos-sans?styles=171347" rel="stylesheet">
    <componenet is="style">
      .care-label-background {
        font-family: 'HarmonyOS Sans', sans-serif;
        position: relative;
        font-weight: bold;
        font-size: 3mm;
        color: #000;
        width: 40mm;
      }

      .name,
      .number,
      .qrcode {
        position: absolute;
      }

      .number {
        top: 81.1mm;
        left: 10.5mm;
      }

      .name {
        top: 90.9mm;
        left: 10.5mm;
      }

      .svg {
        width: 100%;
        height: auto;
      }

      .qrcode {
        width: 18.54mm;
        height: 18.54mm;
        bottom: 10mm;
        left: 50%;
        transform: translateX(-50%);
      }
    </componenet>

    <div class="number">
      {{ number }}
    </div>
    <div class="name">
      {{ customerName }}
    </div>
    <div class="qrcode">
      <vue-qrcode :value="url" tag="svg" :options="{ width: 70 }" />
    </div>

    <img class="svg" :src="BackgroundSvg" alt="background" />
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import backgroundSvg from './background.svg';

@Component({
  components: { VueQrcode }
})
export default class Background extends Vue {
  @Prop(String) number;
  @Prop(String) customerName;
  @Prop(String) url;

  BackgroundSvg = backgroundSvg;
}
</script>
